import type { Movie } from '~/models/movie';
import { RT_URL } from '~/globals/rt-urls';
import type { RTMovie } from '~/models/rt-movie';
import type { RTTVSeries } from '~/models/rt-tv-series';
import type { TVSeries } from '~/models/tv-series';

export const getLiteMovie = (movie: Readonly<RTMovie>): Movie => {
	const liteMovie: Movie = {
		title: movie.name,
		url: new URL(movie.url, RT_URL)
	};

	if (movie.meterScore !== null && !isNaN(movie.meterScore)) liteMovie.score = movie.meterScore;
	if (movie.year !== null && !isNaN(movie.year)) liteMovie.year = movie.year;

	return liteMovie;
};

export const getLiteTvSeries = (series: Readonly<RTTVSeries>): TVSeries => {
	const liteSeries: TVSeries = {
		title: series.title,
		url: new URL(series.url, RT_URL)
	};

	if (series.meterScore !== null && !isNaN(series.meterScore)) liteSeries.score = series.meterScore;
	if (series.startYear !== null && !isNaN(series.startYear)) liteSeries.year = series.startYear;

	return liteSeries;
};
